import type { Phase } from "states/lifecyclePhases";
import type { Variant } from "states/variants";
import type { SpecificationMetadata, SpecificationMetadataState } from "types";

export function generateSpecificationMetadataFromState({
  state,
  variants,
  phases,
}: {
  state: SpecificationMetadataState;
  variants: Variant[];
  phases: Phase[];
}): SpecificationMetadata | null {
  const variant = variants.find((v) => v.id === state.mainVariantId);
  const phase = phases.find((p) => p.id === state.phaseId);
  if (!variant || !phase) return null;
  return {
    id: state.id,
    mainVariant: variant,
    phase,
    variants:
      state.variantIds
        ?.map((id) => variants.find((v) => v.id === id))
        .filter((v) => v !== undefined) ?? [],
  };
}
